export default "__VITE_ASSET__BuM0ClEG__"